import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { UpdateMobileNoStackRoutes, UpdateMobileNoStackScreenProps } from '@/features/account-management/screens/update-mobile-no/type';
import { UpdateMobileNoWebZeroScreen } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoWebZero.screen';
import { UpdateMobileNoNativeZeroScreen } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoNativeZero.screen';

export const UpdateMobileNoMain: React.FC<UpdateMobileNoStackScreenProps<UpdateMobileNoStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, func, record, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <UpdateMobileNoNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <UpdateMobileNoWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
